export const PERMISSION_FEATURES = {
  LIST: "list",
  CREATE: "create",
  VIEW: "view",
  EDIT: "edit",
  DELETE: "delete",
  IMPORT: "import",
  ENABLE: "enable",
};

export const MODULES = {
  APPOINTMENT: "appointment",
  PATIENT: "patient",
  GUARDIAN: "guardian",
  INVENTORY: "inventory",
  SUPPLIER: "supplier",
  BILLING: "billing",
  DASHBOARD: "dashboard",
  SETTINGS: "settings",
  COMMUNICATIONS: "communications",
};

export const MODULE_KEYS = {
  [MODULES.PATIENT]: "patients_guardian",
  [MODULES.INVENTORY]: "inventory_pharmacy",
  [MODULES.APPOINTMENT]: "appointments",
  [MODULES.COMMUNICATIONS]: "sms_notifications",
};
